import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

interface IProps {
    className?: string
}

const AIIcon: React.FC<IProps> = ({ className }) => (
    <div className={classNames(styles.icon, className)}>
        <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    </div>
)

export default AIIcon 